"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnimplementedExpression = exports.Expression = void 0;
var util_1 = require("../util/util");
var builder_1 = require("./builder");
var Expression = /** @class */ (function () {
    function Expression(json) {
        if (json.operand != null) {
            var op = (0, builder_1.build)(json.operand);
            if ((0, util_1.typeIsArray)(json.operand)) {
                this.args = op;
            }
            else {
                this.arg = op;
            }
        }
        if (json.localId != null) {
            this.localId = json.localId;
        }
    }
    Expression.prototype.execute = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var execValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.localId != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.exec(ctx)];
                    case 1:
                        execValue = _a.sent();
                        ctx.rootContext().setLocalIdWithResult(this.localId, execValue);
                        return [2 /*return*/, execValue];
                    case 2: return [2 /*return*/, this.exec(ctx)];
                }
            });
        });
    };
    Expression.prototype.exec = function (_ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this];
            });
        });
    };
    Expression.prototype.execArgs = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.args != null) {
                    return [2 /*return*/, Promise.all(this.args.map(function (arg) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, arg.execute(ctx)];
                        }); }); }))];
                }
                else if (this.arg != null) {
                    return [2 /*return*/, this.arg.execute(ctx)];
                }
                else {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/];
            });
        });
    };
    return Expression;
}());
exports.Expression = Expression;
var UnimplementedExpression = /** @class */ (function (_super) {
    __extends(UnimplementedExpression, _super);
    function UnimplementedExpression(json) {
        var _this = _super.call(this, json) || this;
        _this.json = json;
        return _this;
    }
    UnimplementedExpression.prototype.exec = function (_ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("Unimplemented Expression: ".concat(this.json.type));
            });
        });
    };
    return UnimplementedExpression;
}(Expression));
exports.UnimplementedExpression = UnimplementedExpression;
//# sourceMappingURL=expression.js.map